"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var antd_1 = require("antd");
var react_1 = __importStar(require("react"));
var store_1 = require("../../store");
var Forbidden_1 = __importDefault(require("../../views/Forbidden"));
var Permission_1 = require("../Permission");
var Sider = antd_1.Layout.Sider, Content = antd_1.Layout.Content;
var MasterDetailView = function (props) {
    var master = props.master, detail = props.detail;
    var setMasterAreaCollapsed = store_1.useActions(function (actions) { return actions.ui.setMasterAreaCollapsed; });
    var masterAreaCollapsed = store_1.useStore(function (state) { return state.ui.masterAreaCollapsed; });
    var guide = store_1.useStore(function (state) { return state.ui.guide; });
    react_1.useEffect(function () {
        setMasterAreaCollapsed(false);
    }, [setMasterAreaCollapsed]);
    return (react_1.default.createElement(antd_1.Layout, { className: "ant-app-master-layout" },
        react_1.default.createElement(Sider, { theme: "light", collapsible: true, collapsedWidth: 0, trigger: null, collapsed: masterAreaCollapsed, width: 288, className: "ant-app-masterarea" }, master),
        react_1.default.createElement(Content, { className: "ant-app-details-area" }, detail),
        guide));
};
exports.default = Permission_1.withPermission(MasterDetailView, react_1.default.createElement(Forbidden_1.default, null));
